import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const CloseIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="24" height="19" viewBox="0 0 24 19" {...props}>
    <path
      id="Path_24404"
      data-name="Path 24404"
      d="M21,6.611,19.389,5,13,11.389,6.611,5,5,6.611,11.389,13,5,19.389,6.611,21,13,14.611,19.389,21,21,19.389,14.611,13Z"
      transform="translate(-1 -1)"
      fill="#0a1e55"
    />
    <rect id="Rectangle_5930" data-name="Rectangle 5930" width="24" height="24" fill="none" />
  </Svg>
));

CloseIcon.displayName = 'CloseIcon';

export default CloseIcon;
